/**
 * True device ratio (capped) or exactly 1 — never a fraction of it.
 * A fractional ratio gets resampled by the browser and 1px lines crawl.
 */
export function pickPixelRatio(w, h, prev = 0) {
  const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
  const pixels = w * h * dpr * dpr;
  const budget = 8000000;
  if (prev >= dpr - 0.01 && pixels <= budget * 1.35) return dpr;
  if (pixels <= budget) return dpr;
  return 1;
}
